<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <div>
          <material-card>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-btn color="general" light class="mb-2" @click="newItem">{{$t('language.new')}}</v-btn>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="grid.search"
                    append-icon="search"
                    :label="$t('language.search')"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-dialog v-model="dialog" max-width="600px">
              <ValidationObserver ref="form" v-slot="{ passes }">
                <v-form @submit.prevent="passes(save)">
                  <v-card>
                    <v-card-title>{{$t('language.mode')}}</v-card-title>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm6 md6>
                            <ValidationProvider
                              :name="$t('language.name')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="vModel.name"
                                :label="$t('language.name')"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="grey darken-1"
                        text
                        @click="closedialog"
                      >{{$t('language.cancel')}}</v-btn>
                      <v-btn color="blue darken-1" text type="submit">{{$t('language.save')}}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </ValidationObserver>
            </v-dialog>

            <v-data-table
              :headers="grid.headers"
              :items="grid.body"
              :search="grid.search"
              :options.sync="grid.options"
              :server-items-length="grid.total"
              :loading="grid.loading"
              :footer-props="grid.footerProps"
              :items-per-page="grid.itemsperpage"
              class="elevation-2"
            >
              <template v-slot:header.name>
                <span>{{$t("language.name")}}</span>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="editItem(item.id)">edit</v-icon>
                <v-icon small @click="deleteItem(item.id)">delete</v-icon>
              </template>
            </v-data-table>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Base from "../../../shared/Base.vue";
export default {
  name: "modeview",
  extends: Base,
  created() {
    this.grid.headers = [
      { value: "name" },
      { value: "action", sortable: false }
    ];
    this.vModel = {
      id: null,
      name: null
    };
    this.url = "client/setup/modes";
  }
};
</script>